import { Box, Breadcrumbs, Button, ButtonProps, Card, CardContent, Divider, Grid, IconButton, Link, Stack, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import authStore from "../../stores/AuthStore";
import projectsStore from "../../stores/ProjectsStore";
import DeleteIcon from '@mui/icons-material/Delete';
import SimpleBackdrop from "../../components/SimpleBackdrop";
import DialogConfirm from "../../components/DialogConfirm";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SettingProjectCreate: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [project, setProject] = useState('');
    const [description, setDescription] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState({
        open: false,
        title: '',
        message: '',
        color: 'primary' as ButtonProps['color'],
        type: 'create' as 'create' | 'edit' | 'delete'
    });
    const permission: any = authStore.user?.roles.find((role: any) => role.menu.path === '/setting-projects');
    const inputRefs = useRef<HTMLInputElement[]>([]);


    const handleSave = () => {
        setIsLoading(true);
        if (!id) {
            projectsStore.create({
                name: project,
                description: description,
                createBy: authStore.user?.id,
                createAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('บันทึกข้อมูลไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('บันทึกข้อมูลสำเร็จ', { variant: 'success' });
                navigate(`/setting-project-edit/${res.id}`);
            });
        }
    };
    const addRef = (el: any) => {
        if (el && !inputRefs.current.includes(el)) {
            inputRefs.current.push(el);
        }
    };

    const handleKeyDown = (event: any, index: number) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (index + 1 < inputRefs.current.length) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            projectsStore.get(id).then((res) => {
                if (res.error) {
                    enqueueSnackbar('ไม่พบข้อมูล', { variant: 'error' });
                    setIsLoading(false);
                    return;
                }
                setProject(res.name);
                setDescription(res.description);
                setIsLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDelete = async () => {
        setIsLoading(true);
        if (id) {
            projectsStore.update(id, {
                isActive: false,
                updateBy: authStore.user?.id,
                updateAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('ลบโครงการไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('ลบโครงการสำเร็จ', { variant: 'success' });
                navigate('/setting-projects');
            });
        }
    };
    const handleEdit = () => {
        setIsLoading(true);
        if (id) {
            projectsStore.update(id, {
                name: project,
                description: description,
                updateBy: authStore.user?.id,
                updateAt: new Date(),
            }).then((res) => {
                setIsLoading(false);
                if (res.error) {
                    enqueueSnackbar('บันทึกข้อมูลไม่สำเร็จ', { variant: 'error' });
                    return;
                }
                enqueueSnackbar('บันทึกข้อมูลสำเร็จ', { variant: 'success' });
            });
        }
    };
    return (
        <Box component={'div'}>
            <Grid container>
                <Grid item xs={0.5}>
                    <IconButton aria-label="delete" onClick={() => navigate('/setting-projects')}>
                        <ArrowBackIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={8.5} display={'flex'} alignItems={'center'}>
                    <Breadcrumbs separator="›" aria-label="breadcrumb">
                        <Typography>การจัดการ</Typography>
                        <Link component="button" onClick={() => navigate('/setting-projects')}>โครงการ</Link>
                        <Typography variant="h6" color="text.primary">{id ? 'แก้ไข' : 'สร้าง'}</Typography>
                    </Breadcrumbs>
                </Grid>
                <Grid item xs={3} display={'flex'} justifyContent={'end'}>
                    {((permission && permission.delete) || authStore.user?.isSuperAdmin) && id &&
                        <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={() => setOpenConfirm({
                            open: true,
                            title: 'ลบข้อมูล',
                            message: 'คุณต้องการลบโครงการนี้ใช่หรือไม่',
                            color: 'error',
                            type: 'delete'
                        })}>ลบข้อมูล</Button>
                    }
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={2}>
                                <Grid item xs={4} >
                                    <TextField id="outlined-basic" label="ชื่อโครงการ" variant="outlined" fullWidth
                                        onChange={(event) => setProject(event.target.value)} value={project}
                                        inputRef={addRef}
                                        onKeyDown={(e) => handleKeyDown(e, 0)}
                                    />
                                </Grid>
                                <Grid item xs={8} >
                                    <TextField id="outlined-basic" label="รายละเอียด" variant="outlined" fullWidth
                                        onChange={(event) => setDescription(event.target.value)} value={description}
                                        inputRef={addRef}
                                        onKeyDown={(e) => handleKeyDown(e, 1)}
                                    />
                                </Grid>
                                <Grid item xs={12}><Divider /></Grid>
                                <Grid item xs={12} >
                                    <Grid container justifyContent="flex-end">
                                        <Grid item xs={4} >
                                            <Stack spacing={2} direction="row">
                                                <Button variant="outlined" fullWidth onClick={() => navigate('/setting-projects')}>ยกเลิก</Button>
                                                {!id && <Button variant="contained" fullWidth onClick={() => {
                                                    setOpenConfirm({
                                                        open: true,
                                                        title: 'บันทึกเอกสาร',
                                                        message: 'คุณต้องการบันทึกเอกสารนี้ใช่หรือไม่',
                                                        color: 'primary',
                                                        type: 'create'
                                                    });
                                                }}>บันทึก</Button>}
                                                {((permission && permission.edit) || authStore.user?.isSuperAdmin) && id && <Button variant="contained" fullWidth onClick={() => {
                                                    setOpenConfirm({
                                                        open: true,
                                                        title: 'แก้ไขเอกสาร',
                                                        message: 'คุณต้องการแก้ไขเอกสารนี้ใช่หรือไม่',
                                                        color: 'primary',
                                                        type: 'edit'
                                                    });
                                                }}>แก้ไข</Button>}
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <SimpleBackdrop open={isLoading} />
            <DialogConfirm open={openConfirm.open} type={openConfirm.color} title={openConfirm.title} message={openConfirm.message} onClose={() => setOpenConfirm({ ...openConfirm, open: false })}
                onSubmit={() => {
                    setOpenConfirm({ ...openConfirm, open: false });
                    if (openConfirm.type === 'delete') {
                        handleDelete();
                    } else if (openConfirm.type === 'create') {
                        handleSave();
                    } else if (openConfirm.type === 'edit') {
                        handleEdit();
                    }
                }} />
        </Box>
    );
};

export default SettingProjectCreate;
